/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { ExclusiveProductContent } from '../exclusive-product-content.interface';
import { FileService } from '@shared/data-access/services';
import { PDP_CONSTANTS } from '@pdp/app/app.constants';

@Component({
    selector: 'pdp-exclusive-product-promo-message',
    templateUrl: './exclusive-product-promo-message.component.html',
    styleUrls: ['./exclusive-product-promo-message.component.scss'],
    standalone: false
})
export class ExclusiveProductPromoMessageComponent implements OnInit {
	/**
	 * @description String representing the brand of the exclusive product.
	 */
	@Input()
	public brand: string;

	/**
	 * @description Used to reference the json file to reference the correct
	 * data for this exclusive product.
	 */
	public content: ExclusiveProductContent;

	constructor(public fileService: FileService) {}

	ngOnInit(): void {
		const EXCLUSIVE_CONTENT = this.fileService.getDataFileByType$(
			PDP_CONSTANTS.pdpJsonFileName.exclusiveContent,
			'json'
		);

		EXCLUSIVE_CONTENT.subscribe((values) => {
			this.content = values[this.brand];
		});
	}
}
